
import { defineComponent } from 'vue'
import { useStore, mapState, mapGetters } from 'vuex'
import { IconClose } from '@xunlei/thunder-icon-vue'

export default defineComponent({
  components: {
    IconClose,
  },
  setup () {
    const store = useStore()
    return { store }
  },
  computed: {
    ...mapState(['currentIframeUrl', 'currentIframeTitle', 'currentIframeShowClose']),
    ...mapGetters(['isVip', 'isFullScreen']),
  },
  methods: {
    handleBack () {
      this.$router.go(-1)
    },
    handleClose () {
      this.$router.replace({
        path: '/plugin',
        query: this.$route.query,
      })
    },
  },
})
